export default __webpack_public_path__ + "static/media/community7.fe4c6fe0.png";